module.exports = __webpack_public_path__ + "img/face-worried.6199420a.svg";